module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    attrs: {
      "id": "menu"
    }
  }, [_vm._m(0), _vm._v(" "), (!_vm.isErrorNoRTC && !_vm.isIOS && !_vm.isPure) ? _c('local') : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "remote-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.minorError),
      expression: "minorError"
    }],
    staticClass: "error-notification"
  }, [(_vm.minorError === 'WEBSOCKET') ? _c('p', [_vm._v("\n                    " + _vm._s(_vm.$t("error.websocket")) + "\n                ")]) : (_vm.minorError === 'CONNECTION') ? _c('p', [_vm._v("\n                    " + _vm._s(_vm.$t("error.connection")) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deviceError),
      expression: "deviceError"
    }],
    staticClass: "error-notification"
  }, [(_vm.deviceError === 'NO_DEVICES') ? _c('p', [_vm._v("\n                    No devices found.\n                ")]) : (_vm.deviceError === 'NOT_ALLOWED') ? _c('p', [_vm._v("\n                    Please allow Rendezvous to access your devices.\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.audioDeviceError.errorId),
      expression: "audioDeviceError.errorId"
    }],
    staticClass: "info-notification"
  }, [(_vm.audioDeviceError.errorId === 'NOT_ALLOWED') ? _c('p', [_vm._v("\n                    Please allow Rendezvous to access your microphone.\n                ")]) : (_vm.audioDeviceError.errorId === 'NOT_READABLE_DEVICE') ? _c('p', [_c('strong', [_vm._v(_vm._s(_vm.audioDeviceError.deviceName))]), _vm._v(" is not available. Please choose another microphone.\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.videoDeviceError.errorId),
      expression: "videoDeviceError.errorId"
    }],
    staticClass: "info-notification"
  }, [(_vm.videoDeviceError.errorId === 'NOT_ALLOWED') ? _c('p', [_vm._v("\n                    Please allow Rendezvous to access your camera.\n                ")]) : (_vm.videoDeviceError.errorId === 'NOT_READABLE_DEVICE') ? _c('p', [_c('strong', [_vm._v(_vm._s(_vm.videoDeviceError.deviceName))]), _vm._v(" is not available. Please choose another camera.\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.screenShareError),
      expression: "screenShareError"
    }],
    staticClass: "info-notification"
  }, [(_vm.screenShareError === 'SHARING_NOT_ALLOWED') ? _c('p', [_vm._v("\n                    Only one person can share both screen and camera.\n                    "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sharingScreenOnly),
      expression: "!sharingScreenOnly"
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.enableScreenshareOnly($event)
      }
    }
  }, [_vm._v("Share screen only & disable camera")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sharingScreenOnly),
      expression: "sharingScreenOnly"
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.disableScreenshareOnly($event)
      }
    }
  }, [_vm._v("Share camera instead of screen")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onShareScreenErrorDismiss($event)
      }
    }
  }, [_vm._v("Cancel")])]) : _c('p', [_vm._v("\n                    Failed to share the screen: "), _c('strong', [_vm._v(_vm._s(_vm.screenShareError))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sharingScreenAndVideo && !_vm.screenTallyActive),
      expression: "sharingScreenAndVideo && !screenTallyActive"
    }],
    staticClass: "info-notification"
  }, [_c('p', [_vm._v("\n                    You are screen sharing.\n                ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sharingScreenAndVideo && _vm.screenTallyActive),
      expression: "sharingScreenAndVideo && screenTallyActive"
    }],
    staticClass: "info-notification"
  }, [_c('p', [_vm._v("\n                    You are screen sharing. Your screen is live.\n                ")])]), _vm._v(" "), (_vm.isPure) ? _c('info-box', [_c('h1', {
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t("message.welcome.header")))]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.$t("message.welcome.content")) + "\n                ")]), _vm._v(" "), _c('join-prompt')], 1) : _vm._e(), _vm._v(" "), _c('info-box', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isIOS),
      expression: "isIOS"
    }]
  }, [_c('p', [_vm._v("\n                    To join to Wirecast Rendezvous session from an iOS device, please install Wirecast Go from the\n                    App Store.\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "text-centered"
  }, [_c('a', {
    staticStyle: {
      "display": "inline-block",
      "overflow": "hidden",
      "background": "url(//linkmaker.itunes.apple.com/assets/shared/badges/en-us/appstore-lrg.svg) no-repeat",
      "width": "135px",
      "height": "40px",
      "background-size": "contain"
    },
    attrs: {
      "href": "https://itunes.apple.com/us/app/wirecast-go/id987286934?mt=8"
    }
  })])]), _vm._v(" "), _c('info-box', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isError && _vm.isSessionUnknown),
      expression: "isError && isSessionUnknown"
    }]
  }, [_c('h1', {
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t("error.session_unknown.header")))]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.$t("error.session_unknown.content")) + "\n                ")])]), _vm._v(" "), _c('info-box', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isError && _vm.isSessionFull),
      expression: "isError && isSessionFull"
    }]
  }, [_c('h1', {
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t("error.session_full.header")))]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.$t("error.session_full.content")) + "\n                ")])]), _vm._v(" "), _c('info-box', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isError && _vm.isSessionAlreadyConnected),
      expression: "isError && isSessionAlreadyConnected"
    }]
  }, [_c('h1', {
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t("error.session_already_connected.header")))]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.$t("error.session_already_connected.content")) + "\n                ")])]), _vm._v(" "), _c('info-box', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isJoining),
      expression: "isJoining"
    }],
    staticClass: "joining centered"
  }, [_c('p', {
    staticClass: "text-centered"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("message.waiting.content")) + "\n                ")]), _vm._v(" "), _c('spinner', {
    staticClass: "static",
    attrs: {
      "is-visible": "true"
    }
  })], 1), _vm._v(" "), _c('info-box', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isErrorNoRTC),
      expression: "isErrorNoRTC"
    }]
  }, [_c('p', {
    staticClass: "text-centered"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("error.no_rtc.content")) + "\n                ")])]), _vm._v(" "), _c('info-box', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDisconnected),
      expression: "isDisconnected"
    }],
    staticClass: "centered"
  }, [_c('p', {
    staticClass: "text-centered"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("message.session_ended.content")) + "\n                ")])]), _vm._v(" "), _c('participants', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isConnected),
      expression: "isConnected"
    }]
  })], 1), _vm._v(" "), (_vm.chatEnabled) ? _c('chat-panel') : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "id": "app-bar"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/wirecast-rendezvous-logo.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59c95520"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 368
// module chunks = 1